export default __webpack_public_path__ + "assets/9960af34789587ed75ebd19a3e535b23.woff";